<div class="media profile-media">
  <img class="b-r-10" src="assets/images/dashboard/profile.jpg" alt="">
  <div class="media-body"><span>{{this.userDetails?.username}}</span>
    <p class="mb-0 font-roboto">WL User <i class="middle fa fa-angle-down"></i></p>
  </div>
</div>
<ul class="profile-dropdown onhover-show-div">
  <li><a (click)="logout()"><app-feather-icons [icon]="'log-in'"></app-feather-icons><span>Logout</span></a></li>
</ul>
